import { inject, Injectable } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';
import { CanonicalService } from './canonical.service';
import { tap } from 'rxjs';

export interface MetaTagConfig {
  title: string;
  description: string;
  url: string;
  image: string;
}

@Injectable({
  providedIn: 'root',
})
export class MetaService {

  public updateTags = () => tap((config: MetaTagConfig) => this.updateTagsTitleUrl(config));

  private title = inject(Title);
  private meta = inject(Meta);
  private canonical = inject(CanonicalService);

  private updateTagsTitleUrl = (config: MetaTagConfig): void => {
    
    this.title.setTitle(config.title);
    this.canonical.createCanonicalLink(config.url);
    this.setOrUpdateMeta([
      { name: 'title', content: config.title },
      { name: 'description', content: config.description },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: config.url },
      { property: 'og:title', content: config.title },
      { property: 'og:description', content: config.description },
      { property: 'og:image', content: config.image },
      { property: 'og:image:secure_url', content: config.image },
      { property: 'og:image:alt', content: config.title },
      { property: 'twitter:card', content: 'summary_large_image' },
    ]);
  };

  private setOrUpdateMeta = (tags: MetaDefinition[]) => tags.map((tag) => this.meta.getTag(tag.name ? `name='${tag.name}'` : tag.property ? `property='${tag.property}'` : '') ? this.meta.updateTag(tag) : this.meta.addTag(tag));
}
